@use '@design/design-tokens/typography/typography' as *;

.fieldGroup {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.fieldLabel {
  @include typography-v2-body-sm;
  color: var(--text-default);
}
